<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('animal.Animal_info')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('animal.Animal_info') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Arrival')"
                                                :class="activeStep >= 1 ? activeClass : ''" @click="activeStep = 1">
                                                {{ $t('animal.Arrival') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Pedigree')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('animal.Pedigree') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Breed_keeper')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('animal.Breed_keeper') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Studebook')"
                                                :class="activeStep >= 4 ? activeClass : ''" @click="activeStep = 4">
                                                {{ $t('animal.Studebook') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Note')"
                                                :class="activeStep >= 5 ? activeClass : ''" @click="activeStep = 5">
                                                {{ $t('animal.Note') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('animal.Image')"
                                                :class="activeStep >= 6 ? activeClass : ''" @click="activeStep = 6">
                                                {{ $t('animal.Image') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <animal-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"
                                            :breeds="formData.breeds"
                                            :animalGenoTypes="formData.animalGenoTypes"
                                            :animalGenoTypes2="formData.animalGenoTypes2"
                                            :countryCodes="formData.countryCodes"
                                            :animalColours="formData.animalColours"
                                            :animalGenders="formData.animalGenders"
                                            @update:formData="updateFormData"
                                        />
                                        <arrival
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :countryCodes="formData.countryCodes"
                                            :origins="formData.origins"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <pedigree 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :countryCodes="formData.countryCodes"
                                            :nextStep="nextStep" 
                                            :emitter="emitter"
                                            @update:formData="updateFormData"
                                        />
                                        <breed-keeper 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData" 
                                            :breederKeepers="formData.breederKeepers"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <studebook 
                                            v-if="activeStep === 4" 
                                            :class="activeStep === 4 ? activeClass : ''"
                                            :formData="formData" 
                                            :studebookSections="formData.studebookSections"
                                            :studebookStatuses="formData.studebookStatuses"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <note 
                                            v-if="activeStep === 5" 
                                            :class="activeStep === 5 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <Image 
                                            v-if="activeStep === 6" 
                                            :class="activeStep === 6 ? activeClass : ''"
                                            :formData="formData"
                                            ref="animalImgSection"
                                            :emitter="emitter"
                                        />
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 6" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import * as Choices from "choices.js";
import AnimalInfo from "./components/AnimalInfo.vue";
import Arrival from "./components/Arrival.vue";
import Pedigree from "./components/Pedigree.vue";
import BreedKeeper from "./components/BreedKeeper.vue";
import Studebook from "./components/Studebook.vue";
import Note from "./components/Note.vue";
import Image from "./components/Image.vue";
import { nextTick } from 'vue';

import mitt from 'mitt';

    export default {
        name: 'Animal_create_page',
        data() {
            return {
                emitter: mitt(),
                activeStep: 0,
                activeClass: "js-active position-relative",
                formSteps: 7,
                formData: {
                    //Aninal Info
                    associationId: '',
                    ubnId: '',
                    ubn: '',
                    breedId: '',
                    breeds: [],
                    genoTypeId: '',
                    genoTypeId2: '',
                    animalGenoTypes: [],
                    animalGenoTypes2: [],
                    //animalTypeId: '',
                    //animalTypes: [],
                    tagNumber: '',                    
                    animalNumber: '',
                    studbookNumber: '',
                    birthDate: null,
                    countryOfBirthId: '',
                    countryCodes: [],
                    genderId: '',
                    animalGenders: [],
                    colorId: '',
                    animalColours: [],
                    casterated: false,
                    inbreedFactor: null,

                    //Arrival
                    countryCodeId: '',
                    arrivalDate: null,
                    originId: '',
                    origins: [],
                    arrivalFromUBN: '',

                    //Pedigree
                    fatherCountryCodeId: '',
                    fatherTagNumber: '',
                    fatherStudbookNumber: '',
                    motherCountryCodeId: '',
                    motherTagNumber: '',
                    motherStudbookNumber: '',
                    receipientMotherCountryCodeId: '',
                    receipientMotherTagNumber: '',
                    receipientMotherStudbookNumber: '',

                    //BreedKeeper
                    ////Breeder
                    breederKeepers: [],
                    breederId: '',                    
                    breederName: '',  //Not null
                    keeperId: '',
                    keeperName: '',

                    //Studebook
                    studebookSectionId: '',
                    studebookSections: [],
                    studebookStatusId: '',
                    studebookStatuses: [],
                    
                    image: null,
                },
                // Store Choices instance
                choicesInstanceAssociation: null,
                choicesInstanceUbn: null,
                choicesInstanceTag: null,
                choicesInstanceBreed: null,
                choicesInstanceAnimalType: null,
                choicesInstanceGenoType: null,
                choicesInstanceGenoType2: null,
                choicesInstanceCountryCode: null,
                choicesInstanceFatherCountryCode: null,
                choicesInstanceMotherCountryCode: null, 
                choicesInstanceReceipientMotherCountryCode: null,
                choicesInstanceGender: null,
                choicesInstanceAnimalColour: null,
                choicesInstanceOrigin: null,
                choicesInstanceBreeder: null,
                choicesInstanceKeeper: null,
                choicesInstanceStudebookSection: null,
                choicesInstanceStudebookStatus: null
            };
        },
        components: {
            AnimalInfo,
            Arrival,
            Pedigree,
            BreedKeeper,
            Studebook,
            Note,
            Image
        },        
        async mounted() {    
            this.associationId = this.$route.params.id;   
            this.formData.associationId = this.$route.params.id;
            this.formData.ubnId = this.$route.query.ubnId;
            
            await this.fetchAllAnimalInfoDropdownData();
            // Set up listeners once            
            this.emitter.on('animalImageUploaded', this.handleAnimalImageUploaded);
        },
        methods: {               
            async nextStep() {
                if (this.activeStep < this.formSteps -1) {
                    this.activeStep += 1;
                    //console.log(this.activeStep);
                } else {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);
                }   
                                
                if(this.activeStep == 1) {
                    this.fetchAllAnimalArrivalDropdownData();
                }

                if(this.activeStep == 2) {
                    this.fetchAllAnimalPedigreeDropdownData();
                }

                if(this.activeStep == 3) {
                    this.fetchAllAnimalBreederKeeperDropdownData();
                }

                if(this.activeStep == 4) {
                    this.fetchAllAnimalStudebookDropdownData();
                }
            },
            async prevStep() {
                if (this.activeStep > 0) {
                    this.activeStep -= 1;
                    //console.log(this.activeStep);

                    if(this.activeStep == 0) {
                        await this.fetchAllAnimalInfoDropdownData();
                    }

                    if(this.activeStep == 1) {
                        this.fetchAllAnimalArrivalDropdownData();
                    }

                    if(this.activeStep == 2) {
                        this.fetchAllAnimalPedigreeDropdownData();
                    }

                    if(this.activeStep == 3) {
                        this.fetchAllAnimalBreederKeeperDropdownData();
                    }

                    if(this.activeStep == 4) {
                        this.fetchAllAnimalStudebookDropdownData();
                    }
                }
            },
            async fetchAllAnimalInfoDropdownData() {
                try {
                    this.$store.commit('setShowLoading', true);
                    
                    await this.fetchUBN();
                    await this.fetchAllBreedData();
                    await this.fetchAllGenoTypeData();
                    await this.fetchAllGenoTypeData2();
                    await this.fetchAllCountryCodeData();
                    await this.fetchAllGenderData();
                    await this.fetchAllAnimalColourData();
                    await this.fetchAllOriginData(); 

                    await nextTick();
                        
                    this.initializeChoicesDropdown({
                        id: "countryOfBirthId",
                        dataList: this.formData.countryCodes,
                        selectedValue: this.formData.countryOfBirthId,
                        instanceKey: "choicesInstanceCountryCode"
                    });
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            },
            async fetchAllAnimalArrivalDropdownData() {
                try {
                    this.$store.commit('setShowLoading', true);
                    
                    await this.fetchAllCountryCodeData();
                    await this.fetchAllOriginData(); 

                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "originId",
                        dataList: this.formData.origins,
                        selectedValue: this.formData.originId,
                        instanceKey: "choicesInstanceOrigin"
                    });

                    this.initializeChoicesDropdown({
                        id: "countryCodeId",
                        dataList: this.formData.countryCodes,
                        selectedValue: this.formData.countryCodeId,
                        instanceKey: "choicesInstanceCountryCode"
                    });

                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            },
            async fetchAllAnimalPedigreeDropdownData() {
                try {
                    this.$store.commit('setShowLoading', true);
                    
                    await this.fetchAllCountryCodeData();

                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "fatherCountryCodeId",
                        dataList: this.formData.countryCodes,
                        selectedValue: this.formData.fatherCountryCodeId,
                        instanceKey: "choicesInstanceFatherCountryCode"
                    });

                    this.initializeChoicesDropdown({
                        id: "motherCountryCodeId",
                        dataList: this.formData.countryCodes,
                        selectedValue: this.formData.motherCountryCodeId,
                        instanceKey: "choicesInstanceMotherCountryCode"
                    });

                    this.initializeChoicesDropdown({
                        id: "receipientMotherCountryCodeId",
                        dataList: this.formData.countryCodes,
                        selectedValue: this.formData.receipientMotherCountryCodeId,
                        instanceKey: "choicesInstanceReceipientMotherCountryCode"
                    });

                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            },
            async fetchAllAnimalBreederKeeperDropdownData() {
                try {
                    this.$store.commit('setShowLoading', true);
                    
                    await this.fetchAllBreederKeeperData();

                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "breederId",
                        dataList: this.formData.breederKeepers,
                        selectedValue: this.formData.breederId,
                        instanceKey: "choicesInstanceBreeder"
                    });

                    this.initializeChoicesDropdown({
                        id: "keeperId",
                        dataList: this.formData.breederKeepers,
                        selectedValue: this.formData.keeperId,
                        instanceKey: "choicesInstanceKeeper"
                    });

                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            },
            async fetchAllAnimalStudebookDropdownData() {
                try {
                    this.$store.commit('setShowLoading', true);
                    
                    await this.fetchAllStudebookStatusData();
                    await this.fetchAllStudebookSectionData();

                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "studebookStatusId",
                        dataList: this.formData.studebookStatuses,
                        selectedValue: this.formData.studebookStatusId,
                        instanceKey: "choicesInstanceStudebookStatus"
                    });

                    this.initializeChoicesDropdown({
                        id: "studebookSectionId",
                        dataList: this.formData.studebookSections,
                        selectedValue: this.formData.studebookSectionId,
                        instanceKey: "choicesInstanceStudebookSection"
                    });

                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            },  
            async fetchUBN() {
                try {
                    const response = await axios.get(`Location/${this.$route.query.ubnId}`);                    
                    this.gets = response.data;
                    
                    if (this.gets.success) {
                        this.formData.ubnId = this.gets.data.id;
                        this.formData.ubn = this.gets.data.ubn;
                    } else {
                    this.$showError('errors.Contact_system_admin');
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            async fetchAllBreedData() {
                try {
                    const response = await axios.get(`breed/getbyassociation?associationId=${this.associationId}`);
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.breeds = result.data;

                        this.$nextTick(() => {
                            this.initializeChoicesDropdown({
                                id: "breedId",
                                dataList: this.formData.breeds,
                                selectedValue: this.formData.breedId,
                                instanceKey: "choicesInstanceBreed"
                            });
                        });
                    } else {    
                        this.$showError('errors.Error_fetching_breeds');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },           
            async fetchAllGenoTypeData() {
                try {
                    const response = await axios.get("reference/getreference?referenceTypeId=31288ca2-5fed-434b-8d25-cfda6191fbd1"); //GenoType
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.animalGenoTypes = result.data;

                        this.$nextTick(() => {
                            this.initializeChoicesDropdown({
                                id: "genoTypeId",
                                dataList: this.formData.animalGenoTypes,
                                selectedValue: this.formData.genoTypeId,
                                instanceKey: "choicesInstanceGenoType1"
                            });
                        });
                    } else {
                        this.$showError('errors.Error_fetching_genotype');                        
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            async fetchAllGenoTypeData2() {
                try {
                    const response = await axios.get("reference/getreference?referenceTypeId=d84046a2-769f-4882-a3cb-9cf6879192d2"); //GenoType2
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.animalGenoTypes2 = result.data;

                        this.$nextTick(() => {
                            this.initializeChoicesDropdown({
                                id: "genoTypeId2",
                                dataList: this.formData.animalGenoTypes2,
                                selectedValue: this.formData.genoTypeId2,
                                instanceKey: "choicesInstanceGenoType2"
                            });
                        });
                    } else {
                        this.$showError('errors.Error_fetching_genotype2');                        
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },            
            async fetchAllCountryCodeData() {
                try {
                    const response = await axios.get("reference/getreference?referenceTypeId=8e7cedbf-891f-481e-bb84-07efd0aa8188"); //CountryCode
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.countryCodes = result.data;                        
                    } else {
                        this.$showError('errors.Error_fetching_countrycode');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },            
            async fetchAllGenderData() {
                try {
                    const response = await axios.get("reference/getreference?referenceTypeId=9a1d69fe-c91f-4634-80cb-9f56db8d2a46"); //Gender
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.animalGenders = result.data;

                        // Wait for DOM to update
                        this.$nextTick(() => {                            
                            this.initializeChoicesDropdown({
                                id: "genderId",
                                dataList: this.formData.animalGenders,
                                selectedValue: this.formData.genderId,
                                instanceKey: "choicesInstanceGender"
                            });
                        });
                    } else {
                        this.$showError('errors.Error_fetching_gender');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },            
            async fetchAllAnimalColourData() {
                try {                    
                    const response = await axios.get("reference/getreference?referenceTypeId=6d58593a-62f2-4fed-93b9-84eaabbbf47a"); //AnimalColour
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.animalColours = result.data;

                        // Wait for DOM to update
                        this.$nextTick(() => {
                            this.initializeChoicesDropdown({
                                id: "colorId",
                                dataList: this.formData.animalColours,
                                selectedValue: this.formData.colorId,
                                instanceKey: "choicesInstanceAnimalColour"
                            });
                        });
                    } else {
                        this.$showError('errors.Error_fetching_colour');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },            
            async fetchAllOriginData() {
                try {
                    const response = await axios.get("reference/getreference?referenceTypeId=9acd2adf-fdce-4749-b519-cd547cd3d1dc"); //Origin
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.origins = result.data;
                        
                    } else {
                        this.$showError('errors.Error_fetching_origin');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }                
            }, 
            async fetchAllBreederKeeperData() {
                try {
                    const response = await axios.get("user/getuser?role=keeper");
                    const result = response.data;

                    if (result.success && Array.isArray(result.data.userList)) {                        
                        this.formData.breederKeepers = result.data.userList;

                    } else {
                        this.$showError('errors.Error_fetching_keeper');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }                
            },
            async fetchAllStudebookStatusData() {
                try {
                    const response = await axios.get(`studebookstatus/getbyassociation?associationId=${this.associationId}`);
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.studebookStatuses = result.data;
                        
                    } else {  
                        this.$showError('errors.Error_fetching_studebook_status');                        
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            },
            async fetchAllStudebookSectionData() {
                try {
                    const response = await axios.get(`studebooksection/getbyassociation?associationId=${this.associationId}`);
                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.formData.studebookSections = result.data;

                    } else {    
                        this.$showError('errors.Error_fetching_studebook_section');
                    }
                } catch (e) {                    
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                }
            }, 

            initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
                const element = document.getElementById(id);
                if (!element || element.tagName !== "SELECT") {
                    console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                    return;
                }

                // Destroy previous instance if it exists
                if (this[instanceKey]) {
                    this[instanceKey].destroy();
                }

                // Initialize new Choices instance
                this[instanceKey] = new Choices(element, {
                    searchEnabled: true,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: true,
                });

                // Set selected value if it exists in list
                if (selectedValue) {
                    const optionExists = dataList.some(item => item.id === selectedValue);
                    this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
                }
            },

            updateFormData(updatedData) {
                //this.formData = { ...this.formData, ...updatedData };                
                Object.assign(this.formData, updatedData);
            },

            handleAnimalImageUploaded(fileList) {
                console.log('Received image files:', fileList.map(f => f.name));
                this.formData.animalImages = [...fileList]; // always reassign with the full list
            },            
            async uploadImageIfQueued(ref, imageKey) {
                const queuedFiles = ref?.getQueuedFiles?.() || [];

                if (queuedFiles.length > 0) {
                    this.formData[imageKey] = queuedFiles;
                }
            },

            async saveForm() {                
                await this.uploadImageIfQueued(this.$refs.animalImgSection, 'animalImages');
                console.log("animalImages:", this.formData.animalImages);
                this.submitForm();
            },           
            async submitForm() {
                try {
                    this.$store.commit('setShowLoading', true);

                    const formData = new FormData();
                    const ignoredKeys = [
                        'animalColours', 'animalGenders', 'animalGenoTypes', 'animalGenoTypes2',
                        'breederKeepers', 'breeds', 'countryCodes', 'origins',
                        'studebookSections', 'studebookStatuses','associationId'
                    ];

                    for (const key of Object.keys(this.formData)) {
                        if (ignoredKeys.includes(key)) continue;

                        const value = this.formData[key];
                        const isDateField = ['birthDate', 'arrivalDate'];

                        if (isDateField.includes(key) && value instanceof Date) {
                            formData.append(key, value.toISOString().split('T')[0]);
                        } else if (key === 'animalImages' && Array.isArray(value)) {
                            value.forEach((file, index) => {
                                if (file instanceof File || file instanceof Blob) {
                                    console.log(`Appending file #${index + 1}:`, file.name);
                                    formData.append('animalImages', file);
                                }
                            });
                        } else if (value !== null && value !== undefined) {
                            formData.append(key, value);
                        }
                    }

                    if (this.$route.params.id) {
                        formData.append("associationId", this.$route.params.id);
                    }   

                    // Debug formData before sending
                    for (let pair of formData.entries()) {
                        console.log(pair[0], pair[1]);
                    }

                    const response = await axios.post('/animal/create', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });

                    const result = response.data;

                    if (result.success) {
                        this.$showSuccess('errors.Success_animal_created_successfully');                        
                        this.$router.push('/animal');
                    } else {
                        throw new Error('Form submission failed');
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            }
        },
    }
</script>

<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}


.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}


.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>

